import { CTABannerRefProjection } from '../references/CTABannerRef.query';
export const queryPricing = groq`
{
  "pricing": *[
    _type == "pricing" && currentPathname == $currentPathname
  ][0]{
    ...,
    firstCTABanner {
      reference-> ${CTABannerRefProjection}
    },
    secondCTABanner {
      reference-> ${CTABannerRefProjection}
    },
  }
}
`;
